import React from 'react'

import { DocumentSidebarLayoutExtraProps } from '../../components/DocumentSidebarLayout'
import { CanvasFocus } from '../../../canvas/scope'

import PageCanvasView from '../../PageCanvasView/PageCanvasView'
import { FrameQueries } from '../../FrameView'
import { SectionQueries } from '../../SectionView'
import { CanvasRouteComponentProps } from './types'

interface ShareCanvasViewsProps {
  focus: CanvasFocus
  layoutProps: DocumentSidebarLayoutExtraProps
  routeProps: CanvasRouteComponentProps
}

/**
 * The view-specific half of a canvas route: its queries, its chrome, and the
 * left panel it puts beside the canvas.
 *
 * Separate from `ShareCanvasRoute` so the provider stack above it is written
 * once, and so the three still swap freely here without the canvas noticing.
 */
export function ShareCanvasViews({
  focus,
  layoutProps,
  routeProps,
}: ShareCanvasViewsProps) {
  if (focus.kind === 'frame') {
    return <FrameQueries {...layoutProps} {...routeProps} />
  }

  if (focus.kind === 'section') {
    return <SectionQueries {...layoutProps} {...routeProps} />
  }

  return <PageCanvasView {...layoutProps} {...routeProps} />
}
